export default __webpack_public_path__ + "static/media/sign_post.17d8661c.svg";